module.exports = __webpack_public_path__ + "static/media/title_board_r.86c63e47.svg";